import React from 'react';
import SalesActionContainer from '../../containers/salesAction/SalesActionContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const SalesActionPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="영업활동관리/영업활동등록" icon="partner" />
      <SalesActionContainer />
    </>
  );
};

export default SalesActionPage;
